import React from 'react';
import { allcountrieslist } from 'constants/countries.constants';
import DropDown from 'components/Reusable/DropDown';
import { IDropDownProps } from 'components/Reusable/DropDown/dropDown';

export default function NationalitySelect(props: IDropDownProps) {
  return <DropDown {...props} options={allcountrieslist} />;
}
